import { INITIALIZE_FORM } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default (values) =>
    configurationDocumentsActions[INITIALIZE_FORM](values);
